import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import usePageMeta from "@/hooks/usePageMeta";
import { navItems } from "@/mocks/site";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 - 网爆吃瓜",
    description: "你访问的页面不存在或已被移除，回到网爆吃瓜首页继续吃瓜吧。",
  });

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="flex-1 flex items-center">
        <div className="container-page py-20 md:py-28 text-center">
          <span className="mx-auto w-16 h-16 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-3xl">
            <i className="ri-emotion-unhappy-line"></i>
          </span>
          <p className="mt-6 text-sm section-eyebrow">404 Not Found</p>
          <h1 className="mt-3 text-3xl md:text-4xl text-foreground-950">这口瓜没找到，可能已经被吃完了</h1>
          <p className="mt-4 text-sm text-foreground-600">
            访问路径：<span className="text-foreground-800">{location.pathname}</span>
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-home-4-line"></i>
              </span>
              返回首页
            </Link>
          </div>
          <div className="mt-10 flex flex-wrap justify-center gap-2">
            {navItems.slice(1).map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-700 text-xs hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}